import { CountryCode, countriesIndexedByCode } from 'services/base/countries';

export function createLocationFilterOptions(existingEntries: CountryCode[]): CountryCode[] {
  const result: CountryCode[] = [];

  countriesIndexedByCode.forEach((index: number,
                                  code: CountryCode) => {
    const existing = existingEntries.find(entry => entry === code);
    result.push(existing != null ? existing : code);
  });

  return result;
}
